export default __webpack_public_path__ + "static/media/SYS-MATCHSI-0049.3d48a2d5.pdf";